export default function VinculacionFooter() {
    return (
        <footer className="vinculacion-footer text-center py-3">
            <small className="text-muted">
                Desarrollado por SAFITE SAS. Todos los derechos reservados
            </small>
        </footer>
    );
}